import {
  Component,
  ChangeDetectionStrategy,
  inject,
} from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-update-modal',
  templateUrl: './update-modal.component.html',
  styleUrls: ['./update-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IonicModule, TranslatePipe],
})
export class UpdateModalComponent {
  private modalController = inject(ModalController);

  reload() {
    this.modalController.dismiss(null, 'reload');
  }

  dismiss() {
    this.modalController.dismiss(null, 'dismiss');
  }
}
